module.exports = __webpack_public_path__ + "static/img/kid-main-a.4a87ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-main-a.png
// module id = shkp
// module chunks = 0